import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import React from 'react'
import { useForm } from 'react-hook-form';
import { createTicketValidationForm } from '../../utils/validationSchema';
import Form from '../../layouts/Form';
import ComboboxInput from './ComboboxInput';
import APIS from '../../constant/EndPoint';

const CreateTicket = (props: any) => {
  const { handleCreate, isLoading } = props
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createTicketValidationForm),
  });
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ComboboxInput
        url={`${APIS.TICKET_QUEUE}`}
        queryKey={"queue"}
        register={register("queue")}
        errors={errors?.parent}
        name={"queue"}
        label={"Subject"}
        setValue={setValue}
        placeholder={"Search Subject"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={`${APIS.TICKET}available-priority/`}
        queryKey={"priority"}
        register={register("priority")}
        errors={errors?.parent}
        name={"priority"}
        label={"Priority"}
        setValue={setValue}
        placeholder={"Search priority"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className='h-2'></div>
      <label htmlFor="description">Description</label>
      <textarea id="description" rows={6}
        {...register("description")}
        className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
        placeholder="Write a comment..." required></textarea>
    </Form>
  )
}

export default CreateTicket
